<template>
  <v-card flat>
    <v-container style="padding-bottom:0;">
    <v-form ref="form" v-model="form.valid">
      <!-- 画像エリア-->
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">プロフィール画像</v-flex>
        <v-layout v-if="imageURI" row wrap>
          <v-flex xs12>
            <v-avatar size="80"><img :src="imageURI"></v-avatar>
          </v-flex>
          <v-flex xs12>
            <v-btn @click="dialog=!dialog" color="primary">画像を変更する</v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
      <!-- /画像エリア-->
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">名前</v-flex>
        <v-flex xs12>
          <v-text-field 
            v-model="form.name"
            :rules="[rules.required, rules.max50]"
            placeholder="サイト内のお名前" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">自己紹介</v-flex>
        <v-flex xs12>
          <v-textarea
            v-model="form.description"
            :rules="[rules.max500]"
            placeholder="自己紹介を書いてみよう！" style="padding-top:0;" rows="5"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex md2 xs12 class="formElementLabel">ホームページなど</v-flex>
        <v-flex xs12>
          <v-text-field 
            v-model="form.url"
            :rules="[rules.max500]"
            placeholder="https://blog.karaimono.tabetai" style="padding-top:0;"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="formBlock">
        <v-flex xs12>
          <v-btn @click="sendForm()" block dark color="primary">
            <div v-if="isLoading">
              <v-progress-circular
                indeterminate
                color="white"
              ></v-progress-circular>
            </div>
            <div v-else>
              <span v-if="mode=='init'">登録して次へ</span>
              <span v-else>登録する</span>
            </div>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
    </v-container>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title style="padding:0 0 0 10px;">
          プロフィール画像選択
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog=!dialog"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <div>
          <div class="croppa-wrapper">
            <croppa v-model="croppa"
                    :width="200"
                    :height="200"
                    placeholder="タップして画像を選択"
                    placeholder-color="#000"
                    :placeholder-font-size="16"
                    canvas-color="transparent"
                    :show-remove-button="true"
                    remove-button-color="black"
                    :remove-button-size="Number(30)"
                    :show-loading="true"
                    :loading-size="50"
                    :zoom-speed="20"
                    :file-size-limit="2097152"
                    accept="image/png,image/jpeg,image/jpg"
                    @file-type-mismatch="onFileTypeMismatch"
                    @file-size-exceed="onFileSizeExceed"
                    @file-choose="onFileChoosed"
                    @image-remove="onImageRemoved"
            >
            </croppa>
          </div>
          <div class="croppa-compornent">
          </div>
          <div class="container">
            <v-btn v-if="croppa.imageSet" dark color="primary" block @click="generateImage">プロフィール画像に設定する</v-btn>
            <p v-else style="text-align:center">画像を選択してください</p>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { db, storageRef } from '@/main'
// @ is an alias to /src
export default {
  name: 'FoodForm',
  props: {
    mode: {
      type: String,
      default: 'update'
    }
  },
  data () {
    return {
      isLoading: false,
      id: undefined,
      form: {
        name: '',
        description: '',
        url: ''
      },
      imageData: undefined,
      imageURI: undefined,
      isImageChange: false,
      imageUploadedCounter: 0,
      rules: {
        required: v => !!v || '必須項目です。',
        max50: v => {
          return v.length <= 50 || '入力できるのは50文字までです。'
        },
        max500: v => {
          return v.length <= 500 || '入力できるのは500文字までです。'
        }
      },
      dialog: false,
      croppa: {}
    }
  },
  mounted () {
    if (this.user.displayName) this.form.name = this.user.displayName
    if (this.user.description) this.form.description = this.user.description 
    if (this.user.imageurl) this.imageURI = this.user.imageurl
    if (this.user.url) this.form.url = this.user.url
  },
  computed: {
    user () {
      if (this.mode === 'update') return this.$store.state.temp.user
      else {
        let obj = this.$store.state.user
        obj.photoURL = obj.imageurl
        return obj
      }
    }
  },
  methods: {
    async sendForm () {
      if (this.isLoading) return

      this.$refs.form.validate()
      if (!this.form.valid) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: '各項目のエラーメッセージを確認して修正をお願いします。'
        }
        this.$emit('onMessage', obj)
        return
      }
      let sendData = this.makeFormObj()
      this.isLoading = true
      await db.collection('user').doc(this.user.uid).set(sendData, {merge: true})

      // 画像アップ
      if (this.isImageChange) {
        let imageRef = storageRef.child(`profile/${this.user.uid}/profile.png`)
        this.croppa.generateBlob((blob) => {
          imageRef.put(blob)
            .then(() => {
              this.$store.commit('setImageurl', 'profile.png', { root: true })
              this.sendFin()
            })
        })
      } else {
        // 完了
        this.sendFin()
      }
    },
    sendFin () {
      this.isLoading = false

      let obj = {
        group: 'messageBottom',
        type: 'success',
        title: 'Thank you !!',
        text: '登録が完了しました！'
      }
      this.$emit('onMessage', obj)
      this.$emit('onSend')
    },
    makeFormObj () {
      let obj = {
        displayName: this.form.name,
        description: this.form.description,
        url: this.form.url,
      }
      this.$store.commit('setDisplayName', this.form.name, { root: true })
      if (this.isImageChange) {
        obj.photoURL = 'profile.png'
      }
      return obj
    },
    onFileTypeMismatch () {
      let obj = {
        group: 'messageBottom',
        type: 'warning',
        title: '入力エラー',
        text: 'アップロードできるのは画像のみです。'
      }
      this.$emit('onMessage', obj)
    },
    onFileSizeExceed () {
      let obj = {
        group: 'messageBottom',
        type: 'warning',
        title: '入力エラー',
        text: 'ファイルサイズが大きすぎます'
      }
      this.$emit('onMessage', obj)
    },
    onFileChoosed () {
    },
    onImageRemoved () {
    },
    generateImage: function () {
      let url = this.croppa.generateDataUrl()
      if (!url) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '入力エラー',
          text: '画像を選択してください。'
        }
        this.$emit('onMessage', obj)
        return
      }
      this.imageURI = url
      this.isImageChange = true
      this.dialog = false
    }
  },
  components: {
  }
}
</script>
<style scoped>
textarea {
  border: solid 1px #ddd;
}

.formBlock {
  margin-bottom:10px;
}
/* The input */
.formElementLabel {
  text-align: left;
  color:#888;
}
.croppa-wrapper {
  margin: 0 auto;
  width: 200px;
  height: 200px;
}
</style>
